import React, { useState, useLayoutEffect } from 'react'
import { Button, IconButton, CircularProgress, FormControl, InputLabel, Select, MenuItem, } from '@mui/material'
import { makeStyles } from "@material-ui/core";
import clsx from 'clsx'
import LeftIcon from '@material-ui/icons/ArrowLeft'
import RightIcon from '@material-ui/icons/ArrowRight'

const useWindowSize = () => {
  const [size, setSize] = useState([0, 0]);
  useLayoutEffect(() => {
    function updateSize() {
      setSize([window.innerWidth, window.innerHeight]);
    }
    window.addEventListener('resize', updateSize);
    updateSize();
    return () => window.removeEventListener('resize', updateSize);
  }, []);
  return size;
}

const useToolbarStyles = makeStyles((theme) => ({
  viewButton: {
    marginRight: '2ch',
  },
  currentViewButton: {
    opacity: "0.7",
    cursor: 'not-allowed',
    boxShadow: 'none !important'
  },
  navigationContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: '1em',
    alignItems: 'center',
  },
  progressIndicator: {
    height: '15px !important',
    width: '15px !important',
  },
  monthContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
}))

const navigate = {
  PREVIOUS: 'PREV',
  NEXT: 'NEXT',
  TODAY: 'TODAY',
  DATE: 'DATE',
}

const Toolbar = (props) => {
  let {
    localizer: { messages },
    label,
    date,
    loading,
    currentView
  } = props

  const classes = useToolbarStyles()

  const toThisDay = (date) => {
    props.onView('day')
    // give it just a tick to 'set' the view, prior to navigating to the proper date
    setTimeout(() => {
      props.onNavigate(navigate.DATE, date)
    }, 100)
  }

  const navigateAction = (action) => {
    props.onNavigate(action)
  }

  return (
    <div className={classes.navigationContainer}>
      <NavigationButtons navigateAction={navigateAction} messages={messages} />
      <div date={date} onChange={toThisDay} className={classes.monthContainer}>
        <span
          style={{ marginRight: `calc(1em + ${loading ? '0px' : '18px'})` }}
        >
          {label}
        </span>
        {loading ? (
          <CircularProgress className={classes.progressIndicator} />
        ) : null}
      </div>

      <div className='pull-right'>
        <ViewNameGroups messages={messages} viewNames={props.views} currentView={currentView} onView={props.onView}/>
      </div>
    </div>
  )
}

const ViewNameGroups = (props) => {
  const { messages, viewNames, onView, currentView } = props
  const [width, height] = useWindowSize();

  const classes = useToolbarStyles()
  const isSmallScreen = width < 700
  const viewNameArray = Array.isArray(viewNames) ? viewNames : Object.keys(viewNames)

  if (isSmallScreen) {
    return (
      <FormControl variant='outlined' size='small'>
        <InputLabel id='calendar-view-input'>View</InputLabel>
        <Select
          labelId='calendar-view-input'
          value={currentView}
          onChange={(ev) => onView(ev.target.value)}
        >
          {viewNameArray.map((name) => {
            let displayName = messages[name]
            if (displayName === 'Agenda') displayName = 'List'
            if (displayName === 'Work Week') displayName = 'M - F'
            return <MenuItem key={`view name ${displayName}`} value={name}>{displayName}</MenuItem>
          })}
        </Select>
      </FormControl>
    )
  } else {
    return viewNameArray.map((name) => {
      let displayName = messages[name]
      if (displayName === 'Agenda') displayName = 'List'
      if (displayName === 'Work Week') displayName = 'M - F'
      return (
        <Button
          size='small'
          variant='outlined'
          color='primary'
          sx={{ marginRight: '2ch' }}
          key={name}
          onClick={() => onView(name)}
          className={clsx(
            name === currentView && classes.currentViewButton
          )}
        >
          {displayName}
        </Button>
      )
    })
  }
}

const NavigationButtons = props => {
  const { navigateAction, messages } = props
  return (
    <div>
      <Button
        sx={{ marginRight: '2ch' }}
        onClick={() => navigateAction(navigate.TODAY)}
        variant='outlined'
        color='primary'
      >
        {messages.today}
      </Button>
      <IconButton
        sx={{ marginRight: '2ch', borderRadius: '4px', padding: 0 }}
        onClick={() => navigateAction(navigate.PREVIOUS)}
      >
        <LeftIcon style={{ fontSize: '25px' }} />
      </IconButton>
      <IconButton
        sx={{ marginRight: '2ch', borderRadius: '4px', padding: 0 }}
        onClick={() => navigateAction(navigate.NEXT)}
      >
        <RightIcon style={{ fontSize: '25px' }} />
      </IconButton>
    </div>
  )
}

export default Toolbar
